module.exports = __webpack_public_path__ + "static/media/hugo_mobile_1.39fc580d.png";